import {
  RefineTypeSecondary,
  getHitComponent,
  updateInternalSearchSessionStorage,
} from "components/page-components/Internal-Search/utils"

import React from "react"
import { connectInfiniteHits } from "react-instantsearch-dom"

export const CustomInfiniteHits = connectInfiniteHits(
  ({ close_search_modal, hits, searchState, setSearchState, set_focussed }) => {
    const kinds_of_hits = {}
    hits.forEach((hit) => {
      Object.assign(kinds_of_hits, {
        [hit.type]: [...(kinds_of_hits[hit.type] || []), hit],
      })
    })

    return (
      <React.Fragment>
        {Object.entries(kinds_of_hits).map(([type, hits], index) => {
          const { HitsComponent, name } = getHitComponent({ type })

          const refine_type = () => {
            updateInternalSearchSessionStorage({
              last_search_state: {
                ...searchState,
                refinementList: { ...searchState.refinementList, type: [type] },
              },
              focussed: true,
            })
            set_focussed(true)
            setSearchState({
              ...searchState,
              refinementList: { ...searchState.refinementList, type: [type] },
            })
          }
          return (
            <div className="section px-0" key={type + index}>
              <div className="level is-mobile is-clipped px-3">
                <div className="level-left">
                  <div className="level-item">
                    <div
                      onKeyPress={() => {}}
                      role="button"
                      tabIndex="-1"
                      aria-label="refine type"
                      className="title is-4 has-text-white is-clickable title-link"
                      onClick={refine_type}
                    >
                      {name}
                    </div>
                  </div>
                  <RefineTypeSecondary
                    {...{
                      type,
                      refine_type,
                      name,
                    }}
                  />
                </div>
              </div>
              <HitsComponent
                {...{ hits: hits.slice(0, 4), close_search_modal }}
              />
            </div>
          )
        })}
      </React.Fragment>
    )
  }
)
